
import CommunityHighlights from "../components/ourCommunity/CommunityHighlights";
import AboutUsSection from "../components/ourCommunity/AboutUsSection";
import HireTalents from "../components/ourCommunity/HireTalents";
import DedicatedMembers from "../components/ourCommunity/DedicatedMembers";
import JoinUsSection from "../components/JoinUsSection";
import CountUp from "react-countup";
import Layout from "../components/layouts/Layout";
import { BsArrowUp } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProjectSection from "../components/ourCommunity/Our_Projects";

export default function OurCommunity() {
  const counts = [
    { number: 17, description: "Projects Concluded" },
    { number: 250, suffix: "+", description: "Active and Dedicated Members" },
    { number: 4, description: "Awards Won" },
  ];

  const location = useLocation();
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTopBtn(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };


  useEffect(() => {
    const scrollTo = location.state?.scrollTo;
    if (scrollTo) {
      const section = document.getElementById(scrollTo);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);


  return (
    <div>
      <Layout>
        <main className="text-white">

          <div id="aboutUs">
            <AboutUsSection />
          </div>

          <section className="p-4 mt-2 bg-secondary rounded-b-none text-black rounded-2xl px-6 sm:px-10 md:px-14">
            <div className="flex flex-col items-center gap-10 sm:flex-row sm:justify-center sm:gap-16 mt-6 pb-12 text-center">
              {counts.map((count, index) => (
                <div key={index}>
                  <strong className="text-primary text-[4rem] sm:text-[5rem] font-bold">
                    <CountUp
                      end={count.number}
                      duration={5}
                      suffix={count.suffix || ""}
                    />
                  </strong>
                  <p className="text-[16px] sm:text-[18px] font-medium">
                    {count.description}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <CommunityHighlights />

          <div id="projects">
            <ProjectSection />
          </div>

          <div id="hireUs">
            <HireTalents />
          </div>

          <div id="members">
            <DedicatedMembers />
          </div>

          <JoinUsSection />
        </main>

        {showTopBtn && (
          <button
            onClick={() => scrollTo("aboutUs")}
            className="fixed z-50 bottom-6 right-6 p-3 bg-primary text-white rounded-full shadow-lg"
          >
            <BsArrowUp className="h-5 w-5" />
          </button>
        )}
      </Layout>
    </div>
  );
}
